import { render, staticRenderFns } from "./AssignGroups.vue?vue&type=template&id=0e39129e&"
import script from "./AssignGroups.vue?vue&type=script&lang=js&"
export * from "./AssignGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports